import { makeAutoObservable } from "mobx";
class GlobalStores {
  alertShown = false;
  alertPosition = "top-right";
  alertType = "danger";
  alertTitle = "";
  alertMessage = "";

  sidebarCollapse = false;

  t = (key) => key;

  constructor() {
    makeAutoObservable(this);
  }

  setT(data) {
    this.t = data;
  }

  showAlert(title = "Lỗi", message = "Có lỗi xảy ra, vui lòng thử lại", alertType = "danger", position = "top-right") {
    this.alertType = alertType;
    this.alertTitle = title;
    this.alertMessage = message;
    this.alertPosition = position;
    this.alertShown = true;
    setTimeout(() => {
      this.hideAlert();
    }, 2500);
  }

  hideAlert() {
    this.alertShown = false;
    this.alertPosition = "top-right";
    this.alertType = "danger";
    this.alertTitle = "";
    this.alertMessage = "";
  }

  setSidebarCollapse(data) {
    this.sidebarCollapse = data;
  }
}
export const globalStores = new GlobalStores();
